module.exports = __webpack_public_path__ + "img/chart-scatter-bubble.d0b96ba4.svg";